<template>
  <div>
        <!--登录表单-->
        <el-form :inline="true" :model="formData" :rules="rules" ref="formData" class="full-form" :hide-required-asterisk="true" label-width="80px">
            <el-form-item  label="当前企业">
                {{addUseItem.title}}
            </el-form-item>
            <el-form-item prop="truename" label="姓　　名" style="width: 100%;">
                  <el-input v-model.trim="formData.truename"
                    type="text"
                    placeholder="请输入销售姓名"
                    clearable
                    />
            </el-form-item>
            <el-form-item prop="sex" label="性　　别">
                <el-radio-group v-model="formData.sex">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="position_name" label="职　　位">
                <el-select v-model="formData.position_name" placeholder="请选择职位">
                    <el-option v-for="item in $GVAR.position" :key="item.id" :label="item.name" :value="item.name" ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="mobile" label="手机号码">
                <el-input 
                v-model.trim="formData.mobile"  
                type="number"
                placeholder="请输入手机号码"
                clearable
                />
            </el-form-item>
            <el-button class="mt-3" type="primary" style="width: 100%;" @click="submitForm('formData')"  block>确认添加</el-button>
        </el-form>
  </div>
</template>

<script>
import { mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: 'AddPersonnel',
  components: {},
  props: {
    addUseItem: {
      type:Object,
      default:()=>{}
    },
    storeType: {
      type:String,
      default:'0'
    }
  },
  data() {
    return {
        formData:{
            store_id:'',
            store_type:'',
            truename:'',
            sex:'',
            mobile:'',
            position_name:'',
        },
        rules:{
            truename: [
                { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            sex: [
                { required: true, message: '请选择性别', trigger: 'change' }
            ],
            position_name: [
                { required: true, message: '请选择职位', trigger: 'change' }
            ],
            mobile: [{ validator: this.$verify.phoneNumber, trigger: 'blur' }],
        }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_Admin_AddUser']),
        // 添加验证表单
        async submitForm(formName) {
            await this.$refs[formName].validate(async valid => {
                if (valid) {    
                    // 提交表单数据
                    this.formData.store_id = this.addUseItem.id;
                    this.formData.store_type = this.storeType;
                    this.POST_Admin_AddUser({data:this.formData,successFun:()=>{
                        // 提交成功后，清空表单数据
                        this.$refs[formName].resetFields();
                        this.$emit('addSuccess')
                    }})
                } else {    
                return false;
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped>
    .full-form{
        display: flex;
        flex-direction: column; 
    }
</style>

<style>
    .full-form .el-form-item__content{
        width: 81%;
    }
    .full-form .el-select{
        width: 100%;
    }
</style>
